<div class="form-group row" *ngIf="control.visible" [formGroup]="formGroup">
  <div class="col-md-12">
    <hb-df-control-label [control]="control" (onOverrideValue)="overrideValue()"></hb-df-control-label>
  </div>
  <div class="col-md-12">
    <div *ngIf="control.allowUserEntry">
      <p-autoComplete
        [id]="control.key"
        [inputId]="control.formControlId"
        [formControlName]="control.key"
        [suggestions]="filteredOptions"
        (onBlur)="control.lostFocus()"
        (onKeyUp)="control.valueChanged($event.srcElement.value)"
        (onSelect)="control.valueChanged($event)"
        (completeMethod)="filterOptions($event)"
        [size]="100"
        [minLength]="1"
        [placeholder]="control.placeholder || control.label"
        [dropdown]="true"
      ></p-autoComplete>
    </div>
    <div *ngIf="!control.allowUserEntry">
      <select
        class="form-control"
        [id]="control.key"
        [placeholder]="control.placeholder || control.label"
        [formControlName]="control.key"
        (change)="control.valueChanged(control.value)"
      >
        <option *ngFor="let opt of control.options" [value]="opt.label">{{ opt.label }}</option>
      </select>
    </div>
  </div>
</div>
